import { render, staticRenderFns } from "./template.html?vue&type=template&id=5d639a1c&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "../IInput/style.scss?vue&type=style&index=0&id=5d639a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d639a1c",
  null
  
)

export default component.exports